import { render, staticRenderFns } from "./DouceFooter.vue?vue&type=template&id=50eb68f2&"
import script from "./DouceFooter.vue?vue&type=script&lang=js&"
export * from "./DouceFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports